import { render, staticRenderFns } from "./customerBaseDetail.vue?vue&type=template&id=129119fc&scoped=true&"
import script from "./customerBaseDetail.vue?vue&type=script&lang=js&"
export * from "./customerBaseDetail.vue?vue&type=script&lang=js&"
import style0 from "./customerBaseDetail.vue?vue&type=style&index=0&id=129119fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129119fc",
  null
  
)

component.options.__file = "customerBaseDetail.vue"
export default component.exports